//import Swal from "sweetalert2";
//import Vue from "vue";
import { getOnboarding, saveOnboarding, getOnboardings, getOnboardingById} from '@/services/modules/onBoarding'

export const state = {
  onboarding: {
    type_of_business: null,
    business_structure: null,
    legal_business_name: null,
    identification_number: null,
    doing_business_as: null,
    business_website: null,
    legal_last_name: null,
    legal_name: null,
    email_address: null,
    birthday: null,
    street_address: null,
    state: null,
    city: null,
    zip_code: null,
    phone: null,
    social_security_number: null,
    bank_routing_number: null,
    bank_account_number: null
  },
  oboardings: []
}

export const mutations = {
  setOnboarding (state, data) {
    state.onboarding = data
  }
}

export const getters = {
  getOnboarding (state) {
    return state.onboarding
  }
}

export const actions = {
  async fetchOnboarding (context) {
    // eslint-disable-next-line no-unused-expressions
    context
    const result = await getOnboarding()
    //context.commit('setOnboarding', result.data.data)
    return result.data
  },
  async getOnboardings (context) {
    // eslint-disable-next-line no-unused-expressions
    context
    const result = await getOnboardings()
    //context.commit('setOnboarding', result.data.data)
    return result.data
  },
  async getOnboarding (context, {payload}) {
    // eslint-disable-next-line no-unused-expressions
    context
    const result = await getOnboardingById(payload)
    //context.commit('setOnboarding', result.data.data)
    return result.data
  },
  
  async saveOnboarding (context, { payload }) {
    const result = await saveOnboarding(payload)
    if (result.data.status) {
      context.dispatch('fetchOnboarding')
    }
    return result.data
  }
}
